<div fxLayout="column" fxLayoutAlign="start start">
	<span
		i18n="@@footer_label_fundraiserFor"
		class="footer-titles mat-headline-6 fundraiser p-l-xs"
		*ngIf="showFundraiserHeader"
	>
		Fundraiser For
	</span>
	<a
		i18n="@@footer_label_medicalFundraising"
		[href]="medicalHref"
		class="fundraising-medical break-word"
		style="cursor: pointer"
		>Medical Fundraising</a
	>
	<a
		i18n="@@footer_label_fundraisingEducation"
		[href]="fundraisingForHref"
		class="fundraising-education break-word"
		style="cursor: pointer"
		>Fundraising Education</a
	>
	<a
		i18n="@@footer_label_sportsFundraising"
		[href]="sportsHref"
		class="fundraising-sports break-word"
		style="cursor: pointer"
		>Sports Fundraising</a
	>
	<a
		i18n="@@footer_label_crowdfundingMusic"
		[href]="musicHref"
		class="crowdfunding-music break-word"
		style="cursor: pointer"
		>Crowdfunding Music</a
	>
	<a
		i18n="@@footer_label_crowdfundingCharity"
		[href]="crowdfundingCharityHref"
		class="crowdfunding-charity break-word"
		style="cursor: pointer"
		>Crowdfunding Charity</a
	>
	<a
		i18n="@@footer_label_fundraisingForFuneral"
		[href]="funeralHref"
		class="fundraising-funeral break-word"
		style="cursor: pointer"
		>Fundraising for Funeral</a
	>
	<a
		i18n="@@footer_label_fundraisingNonProfits"
		[href]="nonProfitsHref"
		class="fundraising-non-profits break-word"
		style="cursor: pointer"
		>Fundraising Non-Profits</a
	>
	<a
		i18n="@@footer_label_personalFundraising"
		[href]="personalFundraisingHref"
		class="fundraising-personal break-word"
		style="cursor: pointer"
		>Personal Fundraising</a
	>
	<a
		i18n="@@footer_label_corporateGiving"
		[href]="corporateGivingHref"
		class="corporate break-word"
		style="cursor: pointer"
		>Corporate Giving</a
	>
	<a
		[href]="seeMoreHref"
		i18n="@@button_seeMore"
		class="mat-tab-label-active"
		color="accent"
		>See More</a
	>
	<!-- <a [href]="tipsHref">
		<span class="mat-title mat-tab-label-active"
			>See All</span
		></a> -->
</div>
